module.exports = __webpack_public_path__ + "media/images/icon-blind@3x-a4842959132c50f3c8c58742a6c7ec07.png";